import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import AdminNavbar from "components/navbars/adminnavbar.js";
import AdminFooter from "components/footers/adminfooter.js";
import Sidebar from "components/sidebar/sidebar.js";
import PropTypes from 'prop-types';
import routes from "routes.js";

import { connect } from "react-redux";
import { getUserRoleName } from "../views/pages/azureLogin/authUtility";

const ROLE_FLAG_MAP = [
 { flag: "isSuperAdmin", role: "SuperAdmin" },
 { flag: "isAdmin", role: "Admin" },
 { flag: "isVerifier", role: "Verifier" },
 { flag: "isUser", role: "CustomerServiceAgent" },
 { flag: "isECSAgent", role: "ExternalCustomerServiceAgent" },
];

const extractAllowedRoles = (route) => {
  return ROLE_FLAG_MAP
   .filter(({ flag }) => route[flag] === true)
   .map(({ role }) => role);
};

const Admin = (props) => {
  const [sidenavOpen, setSidenavOpen] = useState(true);

   const userRole = getUserRoleName();

  const filteredRoutes = routes.filter((route) => {
   const allowedRoles = extractAllowedRoles(route);
   return allowedRoles.includes(userRole);
  });

  const getRoutes = (routes) => {
    return routes.map((prop) => {
      if (prop.collapse) {
        return getRoutes(prop.views); // Recursively process nested routes
      }
      const allowedRoles = extractAllowedRoles(prop);

      if (prop.layout === "/admin" && allowedRoles.includes(userRole)) {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={prop.path}
          />
        );
      }
      return null;
    });
  };

  const getBrandText = () => {
    const route = routes.find(
        (r) => props.location.pathname.includes(r.layout + r.path)
    );
    return route ? route.name : 'Brand';
  };

  // Toggle sidenav
  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };

  const getNavbarTheme = () => {
    return props.location.pathname.includes("admin/alternative-dashboard")
      ? "light"
      : "dark";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={filteredRoutes} // Use the filtered routes
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: "/",
          imgSrc: require("assets/img/brand/argon-react.png"),
          imgAlt: "...",
        }}
      />
      <div
        className="main-content"
      >
        <div style={{ height: "24vh", backgroundColor: "#172b4d" }}>
          <AdminNavbar
            {...props}
            theme={getNavbarTheme()}
            toggleSidenav={toggleSidenav}
            sidenavOpen={sidenavOpen}
            brandText={getBrandText()}
          />
          {/* Ensure routes are rendered after filtering */}
          {filteredRoutes.length > 0 && (
            <Switch>{getRoutes(filteredRoutes)}</Switch>
          )}
          <AdminFooter />
        </div>
      </div>
      {sidenavOpen ? (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} /> // NOSONAR
      ) : null}
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapDispatchToProps)(Admin);

Admin.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
};